import React from 'react';
import { SkillsViewRendererProps } from '../types';

import Desktop from './Desktop';

function ViewRenderer(props: SkillsViewRendererProps) {
  return <Desktop {...props} />;
}

export default ViewRenderer;
